import React from 'react';

export const SwitchKnobIcon = (props) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_ddd_4715_18560)">
      <circle cx="13" cy="12" r="10" fill="#697FF7" />
    </g>
    <path
      d="M10.9051 17.3372C10.7925 17.3822 10.6686 17.4048 10.5335 17.4048C10.3983 17.4048 10.2745 17.3822 10.1619 17.3372C10.0493 17.2922 9.93666 17.2133 9.82406 17.1007L5.80404 13.0469C5.60134 12.8442 5.5 12.6021 5.5 12.3206C5.5 12.0391 5.60134 11.797 5.80404 11.5943C6.00673 11.3916 6.24883 11.2959 6.53034 11.3072C6.81186 11.3184 7.0427 11.4141 7.22287 11.5943L10.5335 14.9049L18.1344 7.30404C18.337 7.10135 18.5791 7 18.8607 7C19.1422 7 19.3843 7.10135 19.587 7.30404C19.7897 7.50673 19.8854 7.75446 19.8741 8.04723C19.8629 8.34001 19.7671 8.57648 19.587 8.75665L11.2429 17.1007C11.1303 17.2133 11.0177 17.2922 10.9051 17.3372Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_ddd_4715_18560"
        x="0"
        y="0"
        width="26"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4715_18560"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_4715_18560"
          result="effect2_dropShadow_4715_18560"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1"
          operator="erode"
          in="SourceAlpha"
          result="effect3_dropShadow_4715_18560"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_4715_18560"
          result="effect3_dropShadow_4715_18560"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_4715_18560"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
